import { Trans, useTranslation } from 'next-i18next'
import {
	Alert,
	AlertDescription,
	AlertIcon,
	AlertTitle,
} from '~/components/ui/alert'
import { Button } from '~/components/ui/button'
import { useBookingVisitStore } from '../space-visit.store'

export const IntroStep = () => {
	const { t } = useTranslation()
	const setStep = useBookingVisitStore.use.setStep()

	return (
		<div className='flex flex-col gap-4'>
			<Trans
				parent='div'
				i18nKey={'space:visit.dialog.intro.terms'}
			/>

			<Alert className='items-center'>
				<AlertIcon type='neutral' />

				<div>
					<AlertTitle className='flex items-center gap-2'>
						{t('space:visit.dialog.intro.warning.title')}
					</AlertTitle>

					<AlertDescription>
						{t('space:visit.dialog.intro.warning.body')}
					</AlertDescription>
				</div>
			</Alert>

			<Button
				className='w-full'
				onClick={() => setStep('day')}
			>
				{t('space:visit.dialog.intro.start')}
			</Button>
		</div>
	)
}
